export default __webpack_public_path__ + "static/media/Enterprice.b2620f34.png";